import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

const TOKEN_KEY = "kells_vc_handoff_token";
const EMAIL_KEY = "kells_vc_handoff_email";
const PATIENT_ID_KEY = "kells_vc_handoff_patient_id";

/**
 * Opaque bearer token for desktop→mobile virtual checkup (server-minted; not Auth0).
 * Stored in sessionStorage for the duration of the mobile flow.
 */
@Injectable({
  providedIn: "root",
})
export class VirtualCheckupHandoffService {
  private readonly _active$ = new BehaviorSubject<boolean>(this.hasStoredToken());

  readonly isActive$: Observable<boolean> = this._active$.asObservable();

  getToken(): string | null {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  getEmail(): string | null {
    return sessionStorage.getItem(EMAIL_KEY);
  }

  getPatientId(): string | null {
    return sessionStorage.getItem(PATIENT_ID_KEY);
  }

  isActive(): boolean {
    return this.hasStoredToken();
  }

  setSession(token: string, email: string, patientId: string): void {
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(EMAIL_KEY, email);
    sessionStorage.setItem(PATIENT_ID_KEY, patientId);
    this._active$.next(true);
  }

  clear(): void {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(EMAIL_KEY);
    sessionStorage.removeItem(PATIENT_ID_KEY);
    this._active$.next(false);
  }

  private hasStoredToken(): boolean {
    return !!sessionStorage.getItem(TOKEN_KEY);
  }
}
